<template>
  <div class="form-group">
    <label class="form-group__title title-select">{{ label }}</label>
    <v-select  label="name" v-model="inValue" :options="cities" @input="$emit('input', inValue)">
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg
            width="11"
            height="7"
            viewBox="0 0 11 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.5 6.25C5.28906 6.25 5.10156 6.17969 4.96094 6.03906L0.460938 1.53906C0.15625 1.25781 0.15625 0.765625 0.460938 0.484375C0.742188 0.179688 1.23438 0.179688 1.51562 0.484375L5.5 4.44531L9.46094 0.484375C9.74219 0.179688 10.2344 0.179688 10.5156 0.484375C10.8203 0.765625 10.8203 1.25781 10.5156 1.53906L6.01562 6.03906C5.875 6.17969 5.6875 6.25 5.5 6.25Z"
              fill="#434040"
            />
          </svg>
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "BaseSelect",
  props: {
    cities: {
      type: Array
    },
    label: {
      type: String,
      default: '',
    }
  },
  components: {
    vSelect
  },
  data() {
    return {
      inValue: null,
      attributes: {
        ref: "openIndicator",
        role: "presentation",
        class: "vs__open-indicator"
      }
    };
  },
  watch: {
    value(newValue) {
      this.inValue = newValue
    }
  },
};
</script>

<style lang="scss">
:root {
  --vs-dropdown-option--active-bg: #f3f3f3;
  --vs-dropdown-color: #434040;
  --vs-dropdown-option--active-color: #434040;
}
.vs__open-indicator {
  display: flex;
  padding-right: 5px;
}
.vs__dropdown-toggle {
  border-radius: 100px;
  border: 1px solid rgba(67, 64, 64, 0.5);
  height: 41px;
}
.vs--open .vs__dropdown-toggle {
  border-radius: 50px;
  border: 1px solid rgba(67, 64, 64, 0.5);
}
.vs__dropdown-menu {
  border: 1px solid rgba(67, 64, 64, 0.25);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.title-select {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.02em;
  color: #64656a;
}
</style>

